var React = require('react');

function Favicon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"favicon"),React.createElement("g",{"id":"favicon","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},[React.createElement("circle",{"id":"Oval","fill":"#5B00DB","fillRule":"nonzero","cx":"256","cy":"256","r":"256","key":0}),React.createElement("path",{"d":"M274,403.4 C323.2,403.4 358,384.6 385.6,353 L385.6,235 L265.6,235 L265.6,282.2 L337.2,282.2 L337.2,331.8 C315.2,349.4 296,354.2 274,354.2 C204.4,354.2 177.6,306.6 177.6,260.6 C177.6,203 214,157.4 274,157.4 C298.4,157.4 326.4,167.4 345.2,185.4 L378,151.8 C349.2,123.4 311.6,109 274,109 C175.2,109 126,181.8 126,260.6 C126,334.2 168.8,403.4 274,403.4 Z","id":"G","fill":"#FFFFFF","fillRule":"nonzero","key":1})])]);
}

Favicon.defaultProps = {"width":"512px","height":"512px","viewBox":"0 0 512 512","version":"1.1"};

module.exports = Favicon;

Favicon.default = Favicon;
